import { Box, useColorModeValue } from '@chakra-ui/react'


import NavigationBar from '../Components/NavigationBar'
import Footer from '../Components/Footer'
import { PlansList, Features, FaqList } from '../Features/Pricing'
import { Hero } from '../Components/PolicyWrapper'

import GlobalAlertDialog from '../Components/Elements/GlobalAlertDialog'

export const meta = () => {
    return [
        {
            title: 'daddysteach - Pricing',
        },
        {
            name: 'description',
            content: 'Meet your assignment deadlines with Daddysteach! Our team provides expert assistance with college homework questions to help you succeed in your studies. Get the support you need today.'
        },
    ]
}

const Pricing = () => {
    const backgroundColor = useColorModeValue('gray.50', 'gray.900')

    return (
        <Box bgColor={backgroundColor}>
            <NavigationBar />
            <GlobalAlertDialog />
            <Hero label={'Pricing'} />
            <PlansList />
            <Features />
            <FaqList />
            <Footer />
        </Box>
    )
}

export default Pricing